import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { LoadingService } from './../../../core/services/loader.service';
import { UsersService } from '../services/users.service';
import { AuthenticationService } from './../../../core/services/authentication.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { LoginOtpComponent } from '../login-otp/login-otp.component';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  selected = 'option2';
  headline = 'LOGIN TO YOUR ACCOUNT';
  submitted = false;
  submitted2 = false;
  applicationForm: FormGroup;
  status = true;
  loginText = 'Login';
  panelOpenState = false;
  clientForgotMail = '';
  public token;
  hide = true;
  userData;
  // urlArray = [
  //   '/debtapp',
  //   '/financial-goal',
  //   '/user/confirm-identity-and-income',
  //   '/user/complete-review-outstanding-items',
  //   '/user/product-recommendation',
  //   '/user/submission-to-lender',
  //   '/user/loan-approval',
  //   '/user/loan-document',
  //   '/user/settlement-booked',
  //   '/user/settlement-complete',
  // ];
  emailSubject = new Subject();
  // public remember = false;
  constructor(
    public dialogRef: MatDialogRef<LoginComponent>,
    private formBuilder: FormBuilder,
    private userService: UsersService,
    private auth: AuthenticationService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cookieService: CookieService
  ) {}

  /*
  Initilization component
   */

  ngOnInit(): void {
    this.applicationForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    if (this.data.headline) {
      this.headline = this.data.headline;
      if (this.data.email) {
        this.applicationForm.controls.username.setValue(this.data.email);
      }
      if (this.data.disableEmail && this.data.disableEmail == true) {
        this.applicationForm.get('username').disable();
      }
    }
    this.emailSubject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value) => {
        this.checkEmail();
      });
  }

  ngOnDestroy(): void {
    this.emailSubject?.unsubscribe();
  }
  /*
  Form submit
  */

  onSubmit() {
    this.status = false;
    this.submitted = true;
    if (this.applicationForm.invalid) {
      return;
    }
    this.loginText = 'Please wait';
    this.loadingService.startLoading();
    this.userService.login(this.applicationForm.getRawValue()).subscribe(
      (response) => {
        // if (this.remember) {
        //   this.cookieService.set('remember', 'Yes');
        //   this.cookieService.set('username', this.applicationF.username.value);
        //   this.cookieService.set('password', this.applicationF.password.value);
        // } else {
        //   this.cookieService.set('remember', 'No');
        //   this.cookieService.set('username', '');
        //   this.cookieService.set('password', '');
        // }
        // this.loadingService.stopLoading();
        if (response) {
          // console.log('login time +++++');
          // console.log(response.data);

          this.status = false;
          this.setToken(response.data.accessToken);
          this.token = response.data.accessToken;
          this.setImage(response.data.image);
          this.userData = this.auth.getDecodedUserAccessToken();
          this.auth.autoLogout();
          this.loadingService.stopLoading();

          this.auth.fetchingData.next(this.auth.getCurrentUrl());
          this.dialogRef.close('loggedIn');
        }
      },
      (err) => {
        console.log('error', err);
        if (err.error.message === 'check email') {
          const msg =
            'As a first time applicant, an email has been sent to ' +
            this.applicationForm.get('username').value +
            '. Please follow the prompts to create a password and to continue with the application.';
          const header = 'Create Password!';
          this.openConfirmationPopup(
            this.applicationForm.get('username').value,
            header,
            msg
          );
        } else {
          this.auth.showSnackBarMsg('Username and password is incorrect.');
        }
        this.loadingService.stopLoading();
        this.loginText = 'Login';
        this.submitted = false;
      }
    );
  }
  openConfirmationPopup(email, header: string, content: string) {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      data: {
        email,
        header,
        content,
        // emailExist: true, headerData: 'Create Password!'
      },
    });
  }
  onEmailKeyup() {
    const searchText = this.applicationForm.get('username').value;
    this.emailSubject?.next(searchText);
  }
  // loginOtp() {
  //   this.dialogRef.close('otpLogin');
  // }

  checkEmail() {
    // this.loadingService.startLoading();
    const email = this.applicationForm.get('username').value;
    if (email && this.validateEmail(email)) {
      this.userService.getUserByEmail(email).subscribe(
        (response) => {
          if (response.data == 'check email') {
            const msg =
              'As a first time applicant, an email has been sent to ' +
              this.applicationForm.get('username').value +
              '. Please follow the prompts to create a password and to continue with the application.';
            const header = 'Create Password!';
            this.openConfirmationPopup(email, header, msg);
          }
          // this.loadingService.stopLoading()
        },
        (err) => {
          // this.loadingService.stopLoading()
          console.log('error', err);
        }
      );
    }
  }
  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

  /**
   * Sets token
   *
   * @param response User data
   */
  setToken(response) {
    this.auth.setLoginUserDetail(response);
    this.auth.isLoggedIn = true;

    // let returnUrl = sessionStorage.getItem('returnUrl');
    // sessionStorage.removeItem('returnUrl');
    // if (returnUrl) {
    //   this.redirectToURL(returnUrl);
    // } else {
    //   this.redirectToURL();
    // }
  }

  /**
   * Sets image
   *
   * @param response User data
   */
  setImage(response) {
    this.auth.setLoginUserImage(response);
  }

  togglePanel() {
    this.panelOpenState = !this.panelOpenState;
  }
  forgotPassword() {
    this.dialogRef.close('forgotPassword');
  }

  /*
 get form control for validation
  */
  get applicationF() {
    return this.applicationForm.controls;
  }
  // onRegister() {
  //   console.log('this.router.url');
  //   console.log(this.router.url);
  //   if (this.router.url == '/') {
  //     this.snackBar.open('Select an Application.', 'Done', {
  //       duration: 3000,
  //     });
  //   } else {
  //     this.snackBar.open('Please Fill All Details.', 'Done', {
  //       duration: 3000,
  //     });
  //   }
  //   this.dialogRef.close('onRegister');
  // }
}
